import Image from 'next/future/image';
import React, { PropsWithChildren } from 'react';
import { Breakpoints } from 'settings/breakpoints';
import { handleFreeReturn } from '@lambda/commons/helpers';
import deliveryIcon from '@/public/icons/footer/delivery.svg';
import cartIcon from '@/public/icons/footer/cart.svg';
import supportIcon from '@/public/icons/footer/support.svg';
import paymentIcon from '@/public/icons/footer/payment.svg';
import settings from '@/settings';
import { useMediaQuery } from '../../hooks';
import Slider from '@/components/slider/Slider';
import i18n from '@/settings/i18n';

const t = i18n.init();

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

function ItemBox(props: PropsWithChildren<{ title: string; src: string }>) {
  return (
    <div className="inline-block w-full">
      <div className="flex flex-col flex-wrap items-center justify-items-start">
        <div className="w-[24px]">
          <Image
            src={props.src}
            loading="lazy"
            alt={props.title}
            height="24"
            width="24"
            sizes="100vw"
          />
        </div>
        <h3 className="mt-2 text-center text-xs font-bold text-gray-700 xxs:mt-3 xxs:text-sm sm:mt-3 lg:text-base xl:mt-4">
          {t(props.title)}
        </h3>
        <div className="text-center text-xs text-gray-700 xxs:text-sm lg:text-base">
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default function FeaturedSection() {
  const isMobile = useMediaQuery(Breakpoints.SM);
  const breakpoints = {
    [Breakpoints.NONE]: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    [Breakpoints.SM]: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  };

  return (
    <div className="bg-gray-200 py-8 shadow-2xl md:py-10">
      <div className="reebelo-container">
        <div className="px-0 xl:px-20">
          <Slider
            breakpoints={breakpoints}
            loop={isMobile}
            speed={700}
            hideArrow={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
          >
            <ItemBox title="Free Delivery" src={deliveryIcon}>
              {t`Right to your doorstep`}
            </ItemBox>
            <ItemBox title="Satisfaction Promised" src={cartIcon}>
              {t`${{
                free_return_days: freeReturnDays,
              }} Days Free Returns`}
            </ItemBox>
            <ItemBox title="Excellent Support" src={supportIcon}>
              Quick responses
            </ItemBox>
            <ItemBox title="Secure Payment" src={paymentIcon}>
              {t`Several options available`}
            </ItemBox>
          </Slider>
        </div>
      </div>
    </div>
  );
}
